import { useEffect, useState } from 'react';

/**
 * Tracks `document.visibilityState`, for gating polling loops (e.g.
 * useActivityStripFeed) so a backgrounded tab or hidden mobile/WebView view
 * doesn't keep making network requests. Defaults to `true` outside a DOM
 * environment (SSR, tests without jsdom's document) rather than permanently
 * disabling the caller.
 */
export function usePageVisible(): boolean {
  const [isVisible, setIsVisible] = useState(
    () => typeof document === 'undefined' || document.visibilityState === 'visible'
  );

  useEffect(() => {
    if (typeof document === 'undefined') return;

    const onVisibilityChange = () => setIsVisible(document.visibilityState === 'visible');
    onVisibilityChange();

    document.addEventListener('visibilitychange', onVisibilityChange);
    return () => document.removeEventListener('visibilitychange', onVisibilityChange);
  }, []);

  return isVisible;
}
